import { User } from '../../../shared/models/user.model';
import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export class StudentsForImpactListResolver implements Resolve<User[]> {

  constructor(@Inject(StudentsForImpactService) private service: StudentsForImpactService,
    @Inject(LoaderService) private loaderService: LoaderService) { }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User[]> {
    this.loaderService.show();
    return this.service.listImpact();
  }
}
